import { Variant, VariantType } from '@/models'

const CompanyVariants: VariantType[] = [Variant.company, Variant.newCompany, Variant.existingCompany]

export const getIsCompanyVariant = (variant?: VariantType | null) => {
    if (!variant) return false
    return CompanyVariants.includes(variant)
}

export const getIsExistingCompanyVariant = (variant?: VariantType | null) => {
    return variant === Variant.existingCompany
}

export const getIsTaxReturnVariant = (variant?: VariantType | null) => {
    return variant === Variant.taxReturn
}

export const getIsSubscriptionVariant = (variant?: VariantType | null) => {
    if (!variant)
        /** we consider no variant as self employed */
        return true
    return variant !== Variant.quarterlyTaxReturnsAnnualSummary && variant !== Variant.taxReturn
}

export const getIsNewSelfEmployedVariant = (variant?: VariantType | null) => {
    return variant === Variant.newSelfEmployed
}
